import React from 'react'

type Props = {
  className?: string
}

const CreateAccount = ({ className }: Props) => (
  <svg width="64" height="65" viewBox="0 0 64 65" fill="none" className={className}>
    <rect y="0.702637" width="64" height="64" rx="20" fill="#D8E6FF" />
    <path
      d="M37.3333 44.7026V42.036C37.3333 40.6215 36.7714 39.2649 35.7712 38.2647C34.771 37.2645 33.4145 36.7026 32 36.7026H22.6666C21.2522 36.7026 19.8956 37.2645 18.8954 38.2647C17.8952 39.2649 17.3333 40.6215 17.3333 42.036V44.7026"
      stroke="#2979FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.3333 31.3693C30.2789 31.3693 32.6667 28.9815 32.6667 26.036C32.6667 23.0905 30.2789 20.7026 27.3333 20.7026C24.3878 20.7026 22 23.0905 22 26.036C22 28.9815 24.3878 31.3693 27.3333 31.3693Z"
      stroke="#2979FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.6667 31.3693L41.3334 34.036L46.6667 28.7026"
      stroke="#2979FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default CreateAccount
